import { createUseStyles } from 'react-jss'
import { LightTheme } from '../../theme'

export const useStyle = createUseStyles((theme: LightTheme) => ({
  container: {
    backgroundColor: theme.colors.white,
    padding: '24px 0 20px'
  },
  image: {
    zIndex: 1,
  },
  title: {
    padding: '8px 0'
  },
  text: {
    width: '60%',
    marginLeft: 2,
    marginTop: 276
  },
  subText: {
    marginTop: 16
  },
  '@media screen and (max-width: 1440px)': {
    image: {
      height: 500
    }
  },
  '@media screen and (max-width: 1024px)': {
    image: {
      backgroundSize: '80%',
      backgroundPosition: 'top, center left 50px',
    },
    avatarsEmptyMessage: {
      paddingRight: 50
    }
  }
}))
